import { inject, provide } from 'vue';

import type { InjectionKey, Ref, ComputedRef } from 'vue';

export interface IExpandRowProps {
  componentWidth: Ref<number>;
  fixHeader: ComputedRef<boolean | undefined>;
  fixColumn: Ref<boolean>;
  horizonScroll: Ref<boolean>;
}

export const ExpandedRowContextKey: InjectionKey<IExpandRowProps> = Symbol('cds:table:expanded-row');

export const useProvideExpandedRow = (props: IExpandRowProps) => {
  provide(ExpandedRowContextKey, props);
};

export const useInjectExpandedRow = () => {
  return inject(ExpandedRowContextKey, {} as IExpandRowProps);
};
